import { useLanguage } from '@/contexts/language-context';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { storefrontLanguages } from '@/i18n';

export function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();
  const currentLanguage = storefrontLanguages.find((option) => option.code === language);

  return (
    <Select value={language} onValueChange={(value) => setLanguage(value as typeof language)}>
      <SelectTrigger
        aria-label={`${t('Language')}: ${currentLanguage?.label ?? language.toUpperCase()}`}
        data-testid="select-storefront-language"
        className="h-9 w-16 border-0 bg-transparent px-1.5 text-[11px] font-semibold text-foreground shadow-none focus:ring-2 focus:ring-primary focus:ring-offset-0"
      >
        <SelectValue>{currentLanguage?.code.toUpperCase() ?? language.toUpperCase()}</SelectValue>
      </SelectTrigger>
      <SelectContent align="end" className="border-border bg-background text-foreground shadow-xl">
        {storefrontLanguages.map((option) => (
          <SelectItem key={option.code} value={option.code} textValue={option.label} aria-label={option.label}>
            <span aria-hidden="true">{option.code.toUpperCase()}</span>
            <span className="sr-only">{option.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}